import { render, staticRenderFns } from "./qyTrain.vue?vue&type=template&id=6f20764a&scoped=true"
import script from "./qyTrain.vue?vue&type=script&lang=js"
export * from "./qyTrain.vue?vue&type=script&lang=js"
import style0 from "./qyTrain.vue?vue&type=style&index=0&id=6f20764a&prod&lang=scss"
import style1 from "./qyTrain.vue?vue&type=style&index=1&id=6f20764a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20764a",
  null
  
)

export default component.exports